import {
  ListItem,
  ListSubtitle,
  ListTitle,
  SimpleListStyled,
} from './SimpleList.styles';

interface Props {
  title: string;
  subtitle?: { value: string; type: 'default' | 'warning' };
  content: string[];
  'data-testid'?: string;
}

export const SimpleList = ({ title, content, subtitle, ...props }: Props) => (
  <div {...props}>
    <ListTitle>{title}</ListTitle>
    {subtitle && (
      <ListSubtitle type={subtitle.type}>{subtitle.value}</ListSubtitle>
    )}
    <SimpleListStyled>
      {content.map((item, i) => (
        <ListItem key={`${item}-${i}`}>{item}</ListItem>
      ))}
    </SimpleListStyled>
  </div>
);
